import { render, staticRenderFns } from "./FriendRequest.vue?vue&type=template&id=49d883c2&scoped=true&"
import script from "./FriendRequest.vue?vue&type=script&lang=js&"
export * from "./FriendRequest.vue?vue&type=script&lang=js&"
import style0 from "./FriendRequest.vue?vue&type=style&index=0&id=49d883c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d883c2",
  null
  
)

export default component.exports